<agr-dialog id="request-match-dialog" [data]="data" (cancel)="cancel()">
  <div
    class="flex--row flex--justify-space-between border-bottom--gray4 header-container spacing--margin-bottom spacing--margin-top"
  >
    <div
      class="text--bold dialog-title-container spacing--margin-top spacing--margin-bottom spacing--margin-left"
    >
      {{ 'my-dashboard.request-dialog-title' | translate }}
    </div>
    <div
      (click)="cancel()"
      class="close-button-container spacing--margin-top spacing--margin-bottom spacing--margin-right"
    >
      {{ 'slideInDialog.close-button' | translate }}
    </div>
  </div>

  <div
    class="spacing--margin-top spacing--margin-bottom text--h3 title-container spacing--margin-left text--bold"
  >
    {{ 'manureTypes.' + data.selectedRequest?.manureType | translate }}
  </div>

  <div
    class="spacing--margin-top spacing--margin-bottom table-container spacing--margin-left spacing--margin-right"
  >
    <table class="table-no-borders flex--column">
      <tr class="flex--row flex--justify-space-between spacing--margin-bottom border-bottom-gray4">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.manureCategory' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ 'manureCategories.' + data.selectedRequest?.manureCategory | translate }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.manureType' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ 'manureTypes.' + data.selectedRequest?.manureType | translate }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right">
          {{ 'dashboard.overview-table.table-headers.amountInTons' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedRequest?.amountInTons }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.nKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedRequest?.nKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.maxNitrogen' | translate }}
        </td>
        <td class="max-nitrogen-field spacing--margin-left spacing--margin-bottom">
          @if (data.selectedRequest?.nKgPerTon) {
            {{ data.selectedRequest?.nKgPerTon * data.selectedRequest?.amountInTons | number }}
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.pKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedRequest?.pKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.maxPhosphate' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom max-phosphate-field">
          @if (data.selectedRequest?.pKgPerTon) {
            {{ data.selectedRequest?.pKgPerTon * data.selectedRequest?.amountInTons | number }}
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td class="text--bold spacing--margin-right spacing--margin-bottom">
          {{ 'dashboard.overview-table.table-headers.kKgPerTon' | translate }}
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          {{ data.selectedRequest?.kKgPerTon | number }}
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-rightspacing--margin-bottom">{{
            'dashboard.overview-table.table-headers.homogeneous' | translate
          }}</span>
        </td>
        <td class="spacing--margin-left spacing--margin-bottom">
          <div>
            @switch (data.selectedRequest?.isHomogeneous) {
              @case (true) {
                <p>{{ 'homogeneity.homogeneous' | translate }}</p>
              }
              @case (false) {
                <p>{{ 'homogeneity.notHomogenous' | translate }}</p>
              }
              @case (null) {
                <p>{{ 'homogeneity.empty' | translate }}</p>
              }
            }
          </div>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.desiredDeliveryPeriod' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left"
            >{{
              data.selectedRequest?.desiredDeliveryPeriodFrom
                ? ('shorthand-months.' + data.selectedRequest?.desiredDeliveryPeriodFrom
                  | translate)
                : ('' | translate)
            }}
            {{
              data.selectedRequest?.desiredDeliveryPeriodFrom &&
              data.selectedRequest?.desiredDeliveryPeriodTo
                ? '-'
                : ''
            }}
            {{
              data.selectedRequest?.desiredDeliveryPeriodTo
                ? ('shorthand-months.' + data.selectedRequest?.desiredDeliveryPeriodTo | translate)
                : ('' | translate)
            }}
          </span>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.paymentType' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          @if (data.selectedRequest?.paymentType === 'Pay') {
            <span class="you-receive-container text--center">
              {{ 'dashboard.overview-table.paymentType.Pay' | translate }}
            </span>
          } @else {
            <span class="you-pay-container text--center">
              {{ 'dashboard.overview-table.paymentType.Receive' | translate }}
            </span>
          }
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right">{{
            'dashboard.overview-table.table-headers.pricePerTon' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left">{{
            data.selectedRequest?.pricePerTon | currency: 'EUR'
          }}</span>
        </td>
      </tr>

      <tr class="flex--row flex--justify-space-between spacing--margin-bottom">
        <td>
          <span class="text--bold spacing--margin-right test">{{
            'dashboard.overview-table.table-headers.price' | translate
          }}</span>
        </td>
        <td class="spacing--margin-bottom">
          <span class="spacing--margin-left total-price-field">{{
            data.selectedRequest?.amountInTons * data.selectedRequest?.pricePerTon | currency: 'EUR'
          }}</span>
        </td>
      </tr>
    </table>

    <div
      class="spacing--margin-top spacing--margin-bottom text--label information-container border-bottom--gray4"
    >
      *{{ 'resume-page.offer.transport-info' | translate }}
    </div>
  </div>

  @if (selectedLocation$ | async; as selectedLocation) {
    <div
      class="spacing--margin-top spacing--margin-bottom spacing--margin-left spacing--margin-right border-bottom--gray4"
    >
      <mat-label class="text--bold">{{
        'my-dashboard.active-requests-slide-delivery-location' | translate
      }}</mat-label>
      <div class="location-info spacing--margin-top">
        <strong>{{ selectedLocation.name }}</strong
        ><br />
        {{ selectedLocation.street }} {{ selectedLocation.houseNumber }}<br />
        {{ selectedLocation.postalCode }} {{ selectedLocation.city }}<br />
        <span class="edit-location-link" (click)="openLocationsDialog()">Wijzig</span>
      </div>
    </div>
  }

  <div
    class="intermediary-container spacing--margin-top spacing--margin-bottom border-bottom--gray4 spacing--margin-left spacing--margin-right"
  >
    <div class="intermediary-header flex--row">
      <div class="intermediary-text text--bold">
        {{ 'slideInDialog.request.intermediary' | translate }}
      </div>
    </div>

    <div class="intermediary-name spacing--margin-bottom">
      {{ data.selectedRequest?.preferredIntermediary }}
    </div>
  </div>

  <div
    class="action-buttons-container spacing--margin-left spacing--margin-right spacing--margin-bottom"
  >
    <div class="match-button-container spacing--margin-right">
      <agr-primary-action
        [actionText]="'my-dashboard.accept-match-button' | translate"
        actionIcon="add"
        class="spacing--margin-right place-offer-button-container"
        (action)="acceptMatch()"
        disabled="!formGroup.valid"
      ></agr-primary-action>
    </div>

    <div
      class="flex--nowrap flex--row flex--align-center flex--justify-center reject-match-button-container"
    >
      <mat-icon
        _ngcontent-vqd-c258=""
        role="img"
        class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color spacing--margin-left"
        aria-hidden="true"
        data-mat-icon-type="font"
        >add</mat-icon
      >
      <button (click)="rejectMatch()" class="mat-flat-button mat-focus-indicator mat-button-base">
        <div class="footer-button-text-container">
          {{ 'my-dashboard.reject-match-button' | translate }}
        </div>
      </button>
    </div>
  </div>
</agr-dialog>
